import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import {
  Alert,
  Badge,
  Button,
  Card,
  Col,
  Container,
  Image,
  Row,
} from "react-bootstrap";
import { connect } from "react-redux";
import {
  deleteProduct,
  getProductsCount,
  getProductsPaginated,
} from "../../actions/imagedatabase/products";
import APIUrl from "../../APIUrl";
import ConfirmationModal from "../sub/modals/ConfirmationModal";
import TableToolbar from "../sub/bootstrap/TableToolbar";
import Notification from "../sub/Notification";
import Icon from "../sub/Icon";
import Paginator from "../sub/Paginator";
import LoadingSpinner from "../sub/LoadingSpinner";
import ProductModal from "./ProductModal";

class ProductsDatabase extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: null,
      keywordFilter: "",
      isInitialLoading: true,
      isLoading: false,
      totalProducts: 0,
    };

    this.paginator = new Paginator(this);
    this.timeout = null;
  }

  async componentDidMount() {
    try {
      await this.fetchProducts();
    } catch (error) {
      console.error("Failed to fetch data:", error);
    } finally {
      this.setState({ isInitialLoading: false });
    }
  }

  async fetchProducts() {
    this.setState({ isLoading: true });
    this.paginator.disabled = true;

    await this.props.onGetProductsPaginated(
      this.paginator.paginationIndex,
      this.paginator.paginationElems,
      this.state.keywordFilter,
    );

    await new Promise((resolve) => {
      this.props.onGetProductsCount((data) => {
        this.setState({ totalProducts: data, isLoading: false });
        this.paginator.disabled = false;
        resolve();
      });
    });
  }

  closeModal() {
    this.setState({ modal: null });
  }

  openConfModal(title, content, successCallback) {
    this.setState({
      modal: (
        <ConfirmationModal
          size="md"
          title={title}
          content={content}
          successCallback={successCallback}
          closeModal={() => this.closeModal()}
        />
      ),
    });
  }

  deleteImage(id) {
    const successCallback = () => {
      Notification({
        type: "success",
        description: this.props.intl.formatMessage({
          id: "Image.Remove.Success",
        }),
      });

      this.closeModal();
      this.fetchProducts();
    };

    this.props.onDeleteProduct({ _id: id }, successCallback);
  }

  onKeywordFilterChange(value) {
    this.setState({ keywordFilter: value });

    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.fetchProducts();
    }, 800);
  }

  openProductModal(product) {
    this.setState({
      modal: (
        <ProductModal
          product={product}
          closeModal={() => this.closeModal()}
          fetchProducts={() => this.fetchProducts()}
        />
      ),
    });
  }

  render() {
    const { products } = this.props;

    this.paginator.init(
      this.state.totalProducts,
      this.state.totalProducts,
      () => this.fetchProducts(),
    );

    return (
      <Container fluid>
        <TableToolbar>
          <Col>
            <div className="form-inline">
              <input
                id="keyword"
                className="form-control form-control-sm mr-sm-3"
                type="search"
                value={this.state.keywordFilter}
                onChange={(e) => this.onKeywordFilterChange(e.target.value)}
                placeholder={this.props.intl.formatMessage({
                  id: "Search",
                })}
              />

              <Button
                variant="info"
                className="ml-auto"
                onClick={() => this.openProductModal()}
              >
                <Icon icon="circle-plus" /> <FormattedMessage id="Add.Image" />
              </Button>
            </div>
          </Col>
        </TableToolbar>

        {this.state.isInitialLoading ? (
          <LoadingSpinner />
        ) : (
          <>
            {products && products.length <= 0 && (
              <Alert variant="secondary" className="mt-3">
                <FormattedMessage id="Empty.Product" />
              </Alert>
            )}

            {products && products.length > 0 && (
              <Row md={6} className="mb-3">
                {products.map((product) => (
                  <Col className="mb-4" key={product._id}>
                    <Card bg={"light"} className={"h-100"}>
                      <Card.Body className="d-flex flex-column cursor-pointer">
                        <Image
                          src={`${APIUrl.getProductImg}${product._id}/?token=${APIUrl.jwtToken}`}
                          thumbnail
                          alt=""
                        />
                        <Row>
                          <Col className="text-center ps-0 pe-0 mt-2">
                            <small>
                              <strong>
                                <span>{product._id}</span>
                              </strong>
                            </small>
                          </Col>
                        </Row>
                        <Row>
                          {product.keywords &&
                            product.keywords.length !== 0 &&
                            product.keywords.map((k) => (
                              <Col
                                className="text-center ps-0 pe-0 mt-2"
                                key={k}
                              >
                                <Badge size="sm" variant={"secondary"}>
                                  {k}
                                </Badge>
                              </Col>
                            ))}
                        </Row>
                      </Card.Body>
                      <Card.Footer className="text-center">
                        <Button
                          variant="info"
                          size="sm"
                          onClick={() => this.openProductModal(product)}
                        >
                          <Icon icon="pen-to-square" />
                          <FormattedMessage id="Edit" />
                        </Button>
                        <Button
                          className="ml-3"
                          size="sm"
                          variant="danger"
                          onClick={() =>
                            this.openConfModal(
                              <FormattedMessage id="Warning" />,
                              <div>
                                <Alert variant="danger">
                                  <FormattedMessage id="Image.Warning" />
                                </Alert>
                                <FormattedMessage id="Remove.Image.Confirmation" />
                              </div>,
                              () => this.deleteImage(product._id),
                            )
                          }
                        >
                          <Icon icon="trash" />
                        </Button>
                      </Card.Footer>
                    </Card>
                  </Col>
                ))}
              </Row>
            )}

            {this.paginator.render()}

            {this.state.modal}
          </>
        )}
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    products: state.products,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetProductsPaginated: (page, limit, searchQuery) =>
      dispatch(getProductsPaginated(page, limit, searchQuery)),
    onGetProductsCount: (successCallback) =>
      dispatch(getProductsCount(successCallback)),
    onDeleteProduct: (data, successCallback) =>
      dispatch(deleteProduct(data, successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(ProductsDatabase));
